import { render, staticRenderFns } from "./CustomerCare.vue?vue&type=template&id=1e50c8f3&scoped=true"
import script from "./CustomerCare.vue?vue&type=script&lang=js"
export * from "./CustomerCare.vue?vue&type=script&lang=js"
import style1 from "./CustomerCare.vue?vue&type=style&index=1&id=1e50c8f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e50c8f3",
  null
  
)

export default component.exports